var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form_section"},[(_vm.heading)?_c('h2',{staticClass:"form_section--heading"},[_vm._v(_vm._s(_vm.heading))]):_vm._e(),_vm._v(" "),_c('div',{class:['form_section--main', {'columns is-multiline my-0': !_vm.hideColumns}]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }